export default {
    namespaced: true,
    state: {
        quant: 1,
        annexation: 0,
        interface: null,
        /**2023-1-1之后删除 */
        temporarySubNames: ''
    },
    mutations: {
        setQuant(state, payload) {
            state.quant = payload
        },
        setPrice (state, payload) {
            state.annexation = payload
        },
        setInterface (state, payload) {
            state.interface = payload
        },
        /**2023-1-1之后删除 */
        setTemporarySubNames (state, payload) {
            state.temporarySubNames = payload
        },
    },
    getters: {

    },
    actions: {},
    modules: {

    }
}